import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const GiftVoucherOtpConfig = lazy(() => import('../components/GiftVoucherOtpConfig'));

const GiftVoucherOtpConfigRoute: RouteObject = {
  path: '/settings/modules/gift-voucher-otp',
  element: <GiftVoucherOtpConfig />,
};

export default GiftVoucherOtpConfigRoute;
